import React, { Component } from "react";
import PropTypes from "prop-types";

import styles from "./HeaderDropdown.css";

import HeaderDropdownItem from "./HeaderDropdownItem";

export default class HeaderDropdown extends Component {
  constructor(props) {
    super(props);
    this.handleOutsideClick = this._handleOutsideClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleOutsideClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick, false);
  }

  _handleOutsideClick(e) {
    if (!this.node || this.node.contains(e.target)) {
      return;
    }
    this.props.closeDropdown();
  }

  render() {
    return (
      <nav
        className={styles.root}
        ref={node => {
          this.node = node;
        }}
      >
        <ol className={styles.menu}>
          {this.props.items.map((item, i) => (
            <HeaderDropdownItem key={i} {...item} />
          ))}
        </ol>
        <div className={styles.shadow} onClick={this.props.closeDropdown}></div>
      </nav>
    );
  }
}

HeaderDropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeDropdown: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
};
